import React from "react";
import { render } from 'react-snapshot';
import App from "./containers/App";
 

render(<App />, document.getElementById("root"));